<template>
  <v-dialog v-model="dialog" max-width="1200px" content-class="distance-dialog">
    <div style="height: 80vh; background: white; position: relative;">
        <v-toolbar dense dark color="primary elevation-1">
          <v-spacer></v-spacer>
          <v-btn class="distance-button" icon dark @click="showInfo = !showInfo">
            <v-icon v-if="!showInfo" >list_alt</v-icon>
            <v-icon v-else >public</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="close" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
    <div v-if="!mapOnly" class="distance-controller">
      <v-layout wrap>
        <v-flex>

          <v-card class="distance-info elevation-0" :class="{'hideInfo': !showInfo}" style="border: solid 1px lightgrey;">
                  <v-card v-show="false" id="mutas" ref="mutas" class="pt-3 elevation-0"></v-card>
                  <v-card id="output" class="elevation-0 pt-2"></v-card>
          </v-card>
        </v-flex>
      </v-layout>

    </div>
        <div class="distance-map" :class="{'hideMap': showInfo, 'mapOnly': mapOnly}">
          <div id="map" style="border: solid 1px lightgrey; min-height: 350px; width: 100%"></div>
        </div>
    </div>
  </v-dialog>
</template>
<script>
import Styles from '@/components/googlemaps/styles';
import RoutesMap from '@/components/googlemaps/RoutesMap';
import MutasMixin from '@/mixins/mutas'
export default {
  name: 'distanceCheck',
  mixins: [MutasMixin],
  data () {
    return {
      dialog: false,
      orginInput: [],
      destInput: [],
      waypts: [],
      counter: 0,
      limit: 5,
      initInputs: 3,
      routes: null,
      map: null,
      mapEl: null,
      places: [],
      inputs: [],
      placeholder: 'Vul jouw bestemming',
      driverObj: null,
      drivers: [],
      showInfo: false,
      mapOnly: false
    };
  },
  methods: {
    close () {
      this.dialog = false;
      this.$emit('close');
    },
    createMap: function () {
      this.mapEl = document.getElementById('map');
      if(this.mapEl) {
        this.map = new RoutesMap('map', Styles, 15);
      }
    },
    setPlace: function (v) {
      // this.update();
      console.log('setPlace', v);
      // console.log('getIndexes; ', this.map.getIndexes(3));
    },

    update: function () {
      this.waypts = [];

      var inputs = this.places;
      if (inputs[0] && inputs[0].value && inputs[1].value && inputs[2].value) {
        this.orginInput = inputs[0].value;
        this.destInput = inputs[2].value;
        this.waypts.push({
          location: inputs[1].value,
          stopover: true
        });
        /*
        for (i = 1; i < inputs.length; i++) {
          if (inputs[i].value) {
            this.waypts.push({
              location: inputs[i].value,
              stopover: true
            });
            // this.waypts.push(inputs[i].value);
          }
        }
        */
        this.calcRoute();
      } else {
        this.map.reset();
      }
    },
    removeElement: function (index) {
      console.log(index);
      this.inputs.splice(index, 1);
      this.places.splice(index, 1);
      this.update();
    },
    calcRoute: function () {
      this.map.update({
        orginInput: this.orginInput,
        destInput: this.destInput,
        waypts: this.waypts
      });
      // this.map.showRoute(this.places);
      // this.getDirections({
      //   origin: this.orginInput,
      //   destination: this.destInput,
      //   waypoints: this.waypts
      // });

      // this.getDistance(this.places)
    },
    getDistance: function (data) {
      var app = this;
      this.$http
      .post('service/distance/get', data)
      .then(response => {
        app.map.renderData(response.data);
        if (response.data.to && response.data.to[1]) {
          app.calcMutas(response.data.to[1].trip.distance);
        }
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getDirections: function (data) {
      var app = this;
      // console.log('getDirection', data);
      this.$http
      .post('service/distance/getDirections', data)
      .then(response => {
        app.map.setDirections(response.data)
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    show (trip, mapOnly) {
      if (document.getElementById('map')) {
        this.showTrip(trip, mapOnly)
      } else {
        this.dialog = true;
        this.$nextTick(() => {
          this.createMap(this.places);
          this.showTrip(trip, mapOnly)
        });
      }
    },
    showTrip (trip, mapOnly) {
      var i;
      this.places = trip;
      this.mapOnly = mapOnly || false;
      this.waypts = [];
      this.orginInput = this.places[0];
      if (this.places.length > 2) {
        for (i = 1; i < this.places.length - 1; i++) {
          if (this.places[i] !== this.places[i - 1]) {
            this.waypts.push({
              location: this.places[i],
              stopover: true
            });
          }
        }
      }
      this.destInput = this.places[this.places.length - 1];

      this.dialog = true;
      if (!this.mapOnly) {
        this.$nextTick(() => {
          this.calcRoute();
        });
      } else {
        this.map.update({
          orginInput: this.orginInput,
          destInput: this.destInput,
          waypts: this.waypts,
          optimizeWaypoints: false
        });
      }
    }
  },
  mounted () {
    this.createMap(this.places);
  }
};
</script>
<style lang="scss">
@import '../../components/googlemaps/distance.scss';
</style>
